import {
  CalculatedBalanceCollection,
  CalculatedBalanceParams,
  CalculatedBalances,
} from "@bitwarden/web-vault/app/services/store/calculated-balance.collection.abstraction";
import { signal } from "@angular/core";
import { LogLevelType } from "@bitwarden/common/enums/logLevelType";
import {
  BalancesByTimeSet,
  BalanceDate,
  BalancePoint,
} from "@bitwarden/web-vault/app/models/types/balanceGroupingTypes";

export class BalanceByTimeCalculatedCollection extends CalculatedBalanceCollection {
  protected readonly type = "BalanceByTime";
  protected calculations: CalculatedBalances = new Map<string, number>();

  // this map holds the balances by their true timestamps
  protected _balances = signal<Map<string, number>>(new Map());
  // this map holds the times we want to plot which may not necessarily be the true timestamps
  protected _balancePoints = signal<Map<string, BalancePoint>>(new Map());
  readonly balances = this._balances.asReadonly();
  // protected _ins = signal<Map<string, number>>(new Map());
  // readonly ins = this._ins.asReadonly();
  // protected _outs = signal<Map<string, number>>(new Map());
  // readonly outs = this._outs.asReadonly();
  readonly balancePoints = this._balancePoints.asReadonly();

  /**
   * Uses the filteredTransactions stored on the calculation store to update
   * the calculations for balance by account
   */
  async updateCalculations(parameters: CalculatedBalanceParams): Promise<void> {
    const isStale = this.staleCheck();
    const balancesByTime: Record<string, number> = {};
    const balancePoints: Record<string, BalancePoint> = {};

    /*
    const balancesByTimeSet: BalancesByTimeSet = await this.getBalanceByTime(
      parameters.webWorkerQueue,
      parameters.calculatedTransactions,
      parameters.period.startDate,
      parameters.period.endDate,
      parameters.group.granularity,
    );

       if (balancesByTimeSet?.totalBalanceAmounts) {
        this.setBalances(balancesByTimeSet.totalBalanceAmounts);
      }
      if (balancesByTimeSet?.ins) {
        this.setIns(balancesByTimeSet.ins);
      }
      if (balancesByTimeSet?.outs) {
        this.setOuts(balancesByTimeSet.outs);
      }
     */

    const balancePointsFromWorker = await this.getBalanceByTime(
      parameters.webWorkerQueue,
      parameters.calculatedTransactions,
      parameters.period.startDate,
      parameters.period.endDate,
      parameters.group.granularity,
    );

    if (isStale()) {
      return;
    }
    balancePointsFromWorker.forEach((balancePoint) => {
      balancesByTime[balancePoint.balanceDate] = balancePoint.balance;
      balancePoints[balancePoint.plotDate] = balancePoint;
    });

    this.setBalances(balancesByTime);
    this.setBalancePoints(balancePoints);
  }

  getCalculations(): CalculatedBalances {
    return this.calculations;
  }

  protected clearCalculations(): void {
    this.calculations.clear();
    this._balances.set(null);
    this._balancePoints.set(null);
    // this._ins.set(null);
    // this._outs.set(null);
  }

  triggerChanges(): void {}

  initialize() {}

  private setBalances(balancesByTime: Record<string, number>): void {
    this.calculations = new Map(Object.entries(balancesByTime));
    this._balances.set(this.calculations);
  }

  private setBalancePoints(balancePoints: Record<string, BalancePoint>): void {
    const balancePointsMap = new Map<string, BalancePoint>(Object.entries(balancePoints));
    this._balancePoints.set(balancePointsMap);
  }

  /*
  private setIns(insByTime: Record<string, number>): void {
    const insMap = new Map(Object.entries(insByTime));
    this._ins.set(insMap);
  }

  private setOuts(outsByTime: Record<string, number>): void {
    const outsMap = new Map(Object.entries(outsByTime));
    this._outs.set(outsMap);
  }

   */

  clone(): Map<string, number> {
    return new Map(this._balances());
  }

  /*
  cloneIns(): Map<string, number> {
    return new Map(this._ins());
  }

  cloneOuts(): Map<string, number> {
    return new Map(this._outs());
  }
   */
}
